__turbopack_context__.v({
  "banner": "Ze6Iza_banner",
  "banner-bg-highlight-moss-strong": "Ze6Iza_banner-bg-highlight-moss-strong",
  "banner-bg-info": "Ze6Iza_banner-bg-info",
  "banner-bg-success": "Ze6Iza_banner-bg-success",
  "close-button": "Ze6Iza_close-button",
  "content": "Ze6Iza_content",
  "placeholder": "Ze6Iza_placeholder",
});
